
// $(document).on('click', '.following-trigger', function() {
//     $('.endorsed-modal.following').show();
//     $('.profile-sidebar-inner').addClass('modal-open');
// });
//
// $(document).on('click', '.followers-trigger', function() {
//     $('.endorsed-modal.followers').show();
//     $('.profile-sidebar-inner').addClass('modal-open');
// });
//
$('#review-show-followers').hide();
$('#review-show-all').hide();
$(document).on('click', '.reviews-followers', function() {
	stickMe();
    $('#review-show-followers').click();
});

$(document).on('click', '.reviews-everyone', function() {
	stickMe();
    $('#review-show-all').click();
});

$(document).on('click', '.activity-header > span', function() {
	stickMe();
});

